import { Button, IconButton, TextField } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { formDataValidate } from '../../../../../../../utils/formUtils';
import CustomTextField from '../../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import Edit from '@material-ui/icons/Edit';
import { DragIndicator, RemoveCircleRounded } from '@material-ui/icons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { updateDigitalCheckinConfigs } from '../../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../../utils/NotificationUtils';
import { fetchDigitalCheckinConfigs } from '../../../../../configurationSlice';
import { useDispatch } from 'react-redux';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../../env/Configurations';

const DocumentType = (props) => {
  const { hotelId, data, toggleDrawer, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    documentName: {
      value: '',
      fieldName: 'Enter Document Name',
      validations: ['required'],
      errors: {},
    },
    documentCode: {
      value: '',
      fieldName: 'Enter Document Code',
      validations: ['required'],
      errors: {},
    },
  });

  const onCloseDrawer = () => {
    toggleDrawer('', false, '');
  };

  const [document, setDocument] = useReducer((state, newState) => ({ ...state, ...newState }), {
    documents: {
      value: [],
      fieldName: 'Documents',
      validations: [],
      errors: {},
    },
  });

  const clearInputFields = () => {
    Object.keys(formData).forEach((item) => {
      let objCopy = { ...formData[item] };
      objCopy.value = '';
      setFormData({ [item]: objCopy });
    });
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onItemAdd = () => {
    if (validate()) {
      const docCopy = { ...document.documents };
      const currList = [...docCopy.value];
      const newObj = {
        index: currList.length + 1,
        name: formData?.documentName?.value,
        code: formData?.documentCode?.value,
        status: false,
      };
      currList.push(newObj);
      docCopy.value = currList;
      setDocument({ documents: docCopy });
      clearInputFields();
    }
  };

  const onItemDelete = (index, listField) => {
    const currField = { ...document[listField] };
    const list = currField.value;
    list.splice(index, 1);
    currField.value = list;
    setDocument({ [listField]: currField });
  };

  const onItemEdit = (index, listField) => {
    const selectedItem = document.documents.value?.find((item, i) => i === index);
    const formDataCopy = { ...formData };
    formDataCopy.documentCode.value = selectedItem?.code;
    formDataCopy.documentName.value = selectedItem?.name;
    setFormData(formDataCopy);
    onItemDelete(index, listField);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const grid = 8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 6,
    margin: `0 0 ${grid}px 0`,
    color: '#828282',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FBFBFB',
    border: isDragging ? '2px solid #03E67C' : '2px solid #FBFBFB',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#CFF8E0' : '#FFF',
    padding: grid,
    width: '100%',
  });

  const onDragEnd = (result, listField) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(document[listField].value, result.source.index, result.destination.index);
    const mainFormField = { ...formData[listField] };
    mainFormField.value = items;
    setDocument({ [listField]: mainFormField });
  };

  const refactorPayload = () => {
    return document?.documents?.value.map((item) => {
      return {
        name: item.name,
        status: item.status,
        code: item.code,
      };
    });
  };

  const handleOnSubmit = () => {
    try {
      dispatch(stepUpLoaderCount());
      const payload = {
        hotelId: hotelId,
        guestDocumentTypes: refactorPayload(),
      };

      updateDigitalCheckinConfigs(payload).then((res) => {
        notificationManager('success', 'Guest document types updated successfully');
        dispatch(fetchDigitalCheckinConfigs(hotelId));
        onCloseDrawer();
      });
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Fail to update Guest document types');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  useEffect(() => {
    if (data) {
      const documentCopy = { ...document?.document };
      documentCopy.value = data?.map((item, index) => {
        return {
          index: index + 1,
          name: item.name,
          code: item.code,
          status: item.status,
        };
      });
      setDocument({ documents: documentCopy });
    }
  }, [data]);

  return (
    <div className='document-types h-100 container pt-4'>
      <div className='row px-3 w-100 mt-4'>
        <div className='col-md-6'>
          <span className='page-title'>Add New Document type</span>
        </div>
        <div className='col-md-6 d-flex justify-content-end'>
          <IconButton aria-label='delete' onClick={(e) => onCloseDrawer()}>
            <CancelIcon />
          </IconButton>
        </div>
      </div>
      <div className='d-flex h-75 flex-column px-3'>
        <div>
          <div className='row w-100 d-flex'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.documentName}
                handleInputChange={(e) => {
                  setFormData({ documentName: e });
                }}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.documentCode}
                handleInputChange={(e) => {
                  setFormData({ documentCode: e });
                }}
              />
            </div>
          </div>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              onItemAdd();
            }}
            className='mt-2'
          >
            Add
          </Button>
        </div>
        {document?.documents?.value?.length !== 0 && (
          <div className='col-md-12 mb-3 mt-4 drag-item'>
            <div className='hotel-service-subtitle'>Exisiting Types</div>
            <DragDropContext onDragEnd={(e) => onDragEnd(e, 'documents')}>
              <Droppable droppableId='droppable'>
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {document?.documents?.value.map((item, index) => (
                      <Draggable key={'' + item.index} draggableId={'' + item.index} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                            className='list-item'
                          >
                            <DragIndicator className='list-item-drag col-2' />
                            <TextField
                              label='Document Name'
                              id='doc-name'
                              value={item.name}
                              InputProps={{
                                readOnly: true,
                              }}
                              className='mx-2'
                            />
                            <TextField
                              label='Document Code'
                              id='doc-code'
                              value={item.code}
                              InputProps={{
                                readOnly: true,
                              }}
                              className='mx-2'
                            />
                            <Edit
                              onClick={(e) => onItemEdit(index, 'documents')}
                              className='list-item-remove mx-1'
                              color='secondary'
                            ></Edit>
                            <RemoveCircleRounded
                              onClick={(e) => onItemDelete(index, 'documents')}
                              className='list-item-remove mx-1'
                              color='secondary'
                            ></RemoveCircleRounded>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}
      </div>
      <div className='col-md-12 px-3 mt-5 d-flex justify-content-start'>
        <Button
          variant='contained'
          type='submit'
          color='primary'
          size='large'
          onClick={(e) => handleOnSubmit()}
        >
          Save
        </Button>
        <Button
          className='mx-3'
          variant='outlined'
          type='submit'
          color='secondary'
          size='large'
          onClick={(e) => onCloseDrawer()}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default DocumentType;
